import { PalletType, TransactionType } from '@gtpl/shared-models/common-models';
import { ReportingStockDto } from '@gtpl/shared-models/warehouse-management';
import { Injectable } from '@nestjs/common';
import { Shifts } from '../shifts.enum';
import { StockIn } from '../stock-in.entity';
import { StockInDto } from './stock-in.dto';

@Injectable()
export class StockInAdapter {

  public convertDtoToEntity(stockInDto: StockInDto, isUpdate: boolean = false): StockIn {
    console.log("stockInDto stockInDto"+stockInDto.palletCode);
    const stockIn = new StockIn();
    stockIn.saleOrderId = stockInDto.saleOrderId;
    stockIn.saleOrderItemId = stockInDto.saleOrderItemId;
    stockIn.shift = stockInDto.shifts;
    stockIn.reportingDate = stockInDto.reportingDate;
    stockIn.reportedPerson = stockInDto.createdUser;
    stockIn.reportedCases = stockInDto.reportingCases;
    stockIn.palletId = stockInDto.palletId;
    stockIn.rackPostion = stockInDto.rackPostion;
    stockIn.unitId = stockInDto.plantId;
    stockIn.loosePouches = stockInDto.loosePouches;
    stockIn.lotCode = stockInDto.lotCode;
    stockIn.traceCode = stockInDto.traceCode;
    stockIn.manualReported = stockInDto.manualReported;
    // stockIn.receivingPlant=stockInDto.receivingPlant;
    stockIn.coldStorageId = stockInDto.coldStorageId;
    stockIn.pouchesShortage = stockInDto.pouchesStatus;
    stockIn.cartonsShortage = stockInDto.cartonsStatus;
    stockIn.variantId = stockInDto.variantId;
    stockIn.brandId = stockInDto.brandId;
    stockIn.packStyleId = stockInDto.packStyleId;
    stockIn.stockType = stockInDto.stockType;
    stockIn.palletCode = stockInDto.palletCode;
    // stockIn.transaction=stockInDto.transaction;
    // if (stockInDto.palletType === PalletType.new) {
    //   stockIn.transactionType = TransactionType.palleting;
    // }
    // else if (stockInDto.palletType === PalletType.existing) {
    //   stockIn.transactionType = TransactionType.repalleting;
    // }else{
    //   stockIn.transactionType = stockInDto.transactionType;
    // }
    stockIn.transactionType = stockInDto.transactionType;
    stockIn.remarks = stockInDto.remarks;
    stockIn.packingCompleted = stockInDto.packingCompleted;
    if (isUpdate) {
      stockIn.updatedUser = stockInDto.updatedUser;
    } else {
      stockIn.createdUser = stockInDto.createdUser;
    }
    return stockIn;
  }
  public convertEntityToDto(stockInObject: StockIn): StockInDto {
    const stockInDTO = new StockInDto;
    stockInDTO.plantId = stockInObject.unitId;
    stockInDTO.saleOrderId = stockInObject.saleOrderId;
    stockInDTO.saleOrderItemId = stockInObject.saleOrderItemId;
    // stockInDTO.reportedPerson = stockInObject.reportedPerson;
    stockInDTO.palletId = stockInObject.palletId;
    stockInDTO.rackPostion = stockInObject.rackPostion;
    stockInDTO.reportingCases = stockInObject.reportedCases;
    stockInDTO.loosePouches = stockInObject.loosePouches;
    stockInDTO.lotCode = stockInObject.lotCode;
    // stockInDTO.transaction = stockInObject.transaction;  
    // stockInDTO.transactionType = stockInObject.transactionType;  
    stockInDTO.packingCompleted = stockInObject.packingCompleted;
    // stockInDTO.traceCode = stockInObject.traceCode;  
    stockInDTO.shifts = Shifts.shiftA;
    // stockInDTO.receivingPlant = stockInObject.receivingPlant;  
    stockInDTO.coldStorageId = stockInObject.coldStorageId;
    stockInDTO.reportingDate = stockInObject.reportingDate;
    stockInDTO.remarks = stockInObject.remarks;
    // stockInDTO.createdUser = stockInObject.createdUser;
    // stockInDTO.updatedUser = stockInObject.updatedUser;
    return stockInDTO;
  }

  public SaveData(stockInDto: ReportingStockDto, isUpdate: boolean = false): StockIn {
    const stockIn = new StockIn();
    stockIn.saleOrderId = stockInDto.saleOrderId;
    stockIn.saleOrderItemId = stockInDto.saleOrderItemId;
    stockIn.shift = stockInDto.shifts;
    stockIn.reportingDate = stockInDto.reportingDate;
    stockIn.reportedPerson = stockInDto.createdUser;
    stockIn.reportedCases = stockInDto.reportingCases;
    stockIn.palletId = stockInDto.palletId;
    stockIn.rackPostion = stockInDto.rackPostion;
    stockIn.unitId = stockInDto.plantId;
    stockIn.loosePouches = stockInDto.loosePouches;
    stockIn.lotCode = stockInDto.lotCode;
    stockIn.traceCode = stockInDto.traceCode;
    stockIn.manualReported = stockInDto.manualReported;
    stockIn.coldStorageId = stockInDto.coldStorageId;
    stockIn.pouchesShortage = stockInDto.pouchesStatus;
    stockIn.cartonsShortage = stockInDto.cartonsStatus;
    stockIn.variantId = stockInDto.variantId;
    stockIn.brandId = stockInDto.brandId;
    stockIn.packStyleId = stockInDto.packStyleId;
    stockIn.stockType = stockInDto.stockType;
    stockIn.palletCode = stockInDto.palletCode;
    stockIn.transactionType = stockInDto.transactionType;
    stockIn.remarks = stockInDto.remarks;
    stockIn.packingCompleted = stockInDto.packingCompleted;
    stockIn.storeConsumptionId = stockInDto.storeConsumptionId;
    stockIn.warehouseIncharge = stockInDto.warehouseIncharge;
    if (isUpdate) {
      stockIn.updatedUser = stockInDto.updatedUser;
    } else {
      stockIn.createdUser = stockInDto.createdUser;
    }
    return stockIn;
  }
}
